<template>
    <button :type="type" class="inline-flex items-center py-1 px-2 border-0 text-xs uppercase font-semibold text-gray-700 hover:text-lime-800 outline-0 focus:outline-none disabled:opacity-25 transition">
        <slot></slot>
    </button>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'submit',
            },
        }
    })
</script>
